<ng-container *ngFor="let set of sets; let setIndex = index">
  <div *ngIf="setIndex < displayedRows" [class]="setWrapperClass">
    <div
      *ngFor="let item of set.items; let index = index"
      [@fadeIn]
      [style.flexBasis.%]="item.flexBasis"
      [class]="itemWrapperClass"
      (click)="itemClicked.emit(item.galleryItem)"
    >
      <ng-container *ngTemplateOutlet="cardTpl; context: { media: item.galleryItem.media }"></ng-container>
    </div>
  </div>
</ng-container>
<div *ngIf="sets.length > initiallyVisibleRows" class="gallery-btn-wrapper">
  <ng-container *ngIf="sets.length > displayedRows">
    <div class="btn btn-secondary" (click)="displayedRows = displayedRows + moreRows">
      {{ 'MORE' | translate }}
    </div>
    <div class="btn btn-secondary" (click)="displayedRows = sets.length">
      {{ 'SHOW_ALL' | translate }}
    </div>
  </ng-container>
  <div *ngIf="displayedRows >= sets.length" class="btn btn-secondary" (click)="displayedRows = initiallyVisibleRows">
    {{ 'SHOW_LESS' | translate }}
  </div>
</div>

<ng-template #cardTpl let-media="media">
  <mb-media
    [media]="media"
    [class.media-image]="media.type === 'image'"
    [hoverplay]="true"
    [hideTitles]="true"
  ></mb-media>
  <div class="card-footer">
    <mb-action-container
      *ngIf="buttonItems.length"
      [buttonItems]="buttonItems"
      [resource]="media"
      (actionClick)="itemActionClicked.emit({ action: $event, media: media })"
    ></mb-action-container>
  </div>
</ng-template>
